// import { cca_config } from '../../../../../CCA_ENV_CONF/env';
import $ from 'jquery'

export default {
    name: 'confirm-invoice-standardization',
    components: {
        
    },
    props: {
        invoice_data: Object,
        sfe_type_facture: Array,
        modal_state_toggler: Number,
        patient: String
    },
    data() {
        return {
            save_loading: false,
            is_confirm: false,

            selected_type_facture: {},
            type_factures: [],
            type_facture_loading: true,
            type_facture_sfe: '',
            is_online: false,

            client: {
                ifu: '',
                name: ''
            },
            info_client_is_empty: false,
            can_generate_bill: false,
            is_self_client: false
        }
    },

    watch: {
        modal_state_toggler() {
            this.getTypeFactureAvoir()
            this.is_confirm = false 
            this.type_facture_sfe = this.invoice_data.type_facture

            console.log(this.invoice_data.client);
            this.client = this.invoice_data.client
        }
    },

    computed: {
        
    },

    async mounted() {
        window.addEventListener('online', this.handleOnline);
        window.addEventListener('offline', this.handleOffline);

        this.is_online = await this.checkInternetConnection()

        // this.client = this.invoice_data.client
    },

    beforeDestroy() {
        window.removeEventListener('online', this.handleOnline);
        window.removeEventListener('offline', this.handleOffline);
    },

    methods: {
        handleOnline() {
            this.is_online = true;
            this.onReconnect();
        },

        handleOffline() {
            this.is_online = false;
        },
        
        onReconnect() {
            this.is_online = true;
        },

        getTypeFactureAvoir() {
            this.type_facture_loading = true
            this.type_factures = []
            this.sfe_type_facture.forEach(bill_type => {
                if (bill_type.type === 'FA' || bill_type.type === 'EA') {
                    const tmp_aib = {
                        description: bill_type.description,
                        type: bill_type.type
                    }
                    this.type_factures.push(tmp_aib)

                    if (bill_type.type === 'FA') {
                        this.selected_type_facture = tmp_aib
                        this.type_facture_loading = false
                    }
                }
            });
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        nextToConfirm() {
            this.$refs.credit_invoice.click();

            $('.confirm-standardize').modal('show')
            this.invoice_data.type = this.selected_type_facture.type
        },

        generateBill(selector) {
            let confirm = document.getElementById(selector);

            if (confirm.checked == false) { 
                $('.err-msg').fadeIn(500)
                this.save_loading = false
                return
            }

            if (!this.is_online) {
                return;
            }

            this.save_loading = true;
            this.invoice_data.client = this.client
            this.invoice_data.is_self_client = this.is_self_client
            this.invoice_data.can_set_pac = this.can_set_pac

            console.log(this.invoice_data);

            const dispatch_data = (this.type_facture_sfe == 'avoir')?'generateBill':'standardizeInvoice'
            this.$store.dispatch(dispatch_data, this.invoice_data).then((response) => {
                if (response.success) {
                    if (response.is_standardized > 0) {
                        if (this.type_facture_sfe == 'avoir') {
                            this.successToast("Facture générée avec succès")
                        } else {
                            this.successToast("Normalisation effectuée avec succès")
                        }
                    } else {
                        this.warningToast("Erreur lors de la normalisation !")
                    }
                    

                    this.is_confirm = false
                    this.$refs.confirm_standardize.click();
                    this.$router.push({ path: '/factures' })
                } else {
                    if (response.code == 500) {
                        this.$refs.confirm_standardize.click();
                        this.warningToast("Une erreur s'est produite lors de la normalisation de la facture !")
                    } else if (response.code == 400) {
                        this.$refs.confirm_standardize.click();
                        this.warningToast("Une erreur s'est produite : "+response.msg)
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.warningToast("Une erreur s'est produite !")
                this.save_loading = false
            })
        },

        nextToGenBill() {
            this.info_client_is_empty = false
            let info_client = document.getElementById('inf-client');

            this.client.ifu = (this.client.ifu == null)?'':this.client.ifu
            this.client.name = (this.client.name == null)?'':this.client.name

            if (info_client.checked == true) { 
                if (this.client.ifu == '') {
                    this.info_client_is_empty = true
                    return;
                } else if (this.client.name == '') {
                    this.info_client_is_empty = true
                    return;
                } else {
                    this.info_client_is_empty = false
                }
            }

            this.can_generate_bill = true
        },

        backToInfoClient() {
            this.can_generate_bill = false
        },

        handleInfoClient() {
            let info_client = document.getElementById('inf-client');

            if (!info_client.checked) { 
                this.client.ifu = ''
                this.client.name = ''
                this.info_client_is_empty = false
            }
        },

        handleSelfAsClient() {
            let is_client = document.getElementById('self');

            this.is_self_client = is_client.checked
            if (is_client.checked) {
                this.client.name = this.patient
            } else {
                this.client.name = ''
            }
        },

        clearError() {
            this.info_client_is_empty = false
        }
    }
}